import * as React from "react"
import { Icon as CommonIcon, IconProps } from "@chakra-ui/react"
import { IconType } from "react-icons/lib"
import { Tooltip } from "../../common/tooltip"

export interface CommonIconProps extends IconProps {
  src?: IconType
  tooltip?: string
  containerStyles?: React.CSSProperties
}

const _Icon: React.FC<CommonIconProps> = props => {
  const { src, tooltip, containerStyles, ...otherProps } = props
  if (tooltip) {
    return (
      <Tooltip label={tooltip}>
        <span style={{ ...containerStyles, display: "flex" }}>
          {" "}
          <CommonIcon as={src} {...otherProps} />
        </span>
      </Tooltip>
    )
  }
  return <CommonIcon as={src} {...otherProps} />
}

export const Icon = React.memo(_Icon)
